import React, { useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import { PlusIcon } from "../../../utils/svgs"
import { db } from "../../../utils/firebase"

/**
 * UI components
 */
import Table from "../../../components/structure/table/table"
import Enquiry from "../../../components/client/enquiries/enquiry"
import Button from "../../../components/ui/button/button"
import Add from "../../enquiries/add/add"

/**
 * Functional component to return the enquiries for this client
 */
export default function Enquiries({ clientID }) {
	const [enquiries, setEnquiries] = useState([])
	const [deletedEnquiries, setDeletedEnquiries] = useState([])
	const [addingEnquiry, setAddingEnquiry] = useState(false)
	const history = useHistory()

	/**
	 * On component load
	 */
	useEffect(() => {
		/**
		 * Pull all the enquries that are attached to this client ID
		 */
		db.collection("enquiries")
			.orderBy("created")
			.where("client", "==", clientID)
			.get()
			.then((enquiryDocs) => {
				let enquiriesArr = []
				/**
				 * Loop through each of the enquiries
				 */
				enquiryDocs.forEach((enquiry) => {
					/**
					 * Push the enquiry into the array
					 */
					enquiriesArr.push({
						id: enquiry.id,
						...enquiry.data(),
					})
				})
				/**
				 * Then push these enquiries into the state
				 */
				setEnquiries(enquiriesArr)
			})

		/**
		 * Pull all the deleted enquries that are attached to this client ID
		 */
		db.collection("enquiries_removed")
			.orderBy("enquiry.created")
			.where("enquiry.client", "==", clientID)
			.get()
			.then((enquiryDocs) => {
				let deletedEnquiriesArr = []
				/**
				 * Loop through each of the enquiries
				 */
				enquiryDocs.forEach((enquiry) => {
					/**
					 * Push the enquiry into the array
					 */
					deletedEnquiriesArr.push({
						id: enquiry.id,
						...enquiry.data().enquiry,
						archived_from_stats: enquiry.data().archived_from_stats,
					})
				})
				/**
				 * Then push these enquiries into the state
				 */
				setDeletedEnquiries(deletedEnquiriesArr)
			})
	}, [clientID])

	return (
		<>
			{/* New enquiry button */}
			<Button
				label="New enquiry"
				small={true}
				icon={<PlusIcon />}
				className="has-extra-margin"
				onClick={() => setAddingEnquiry(true)}
			/>

			{/* Active enquiries section */}
			<h3 style={{ marginTop: "20px", marginBottom: "10px", fontSize: "16px", fontWeight: 500 }}>Active Enquiries</h3>
			<Table
				className="enquiries-table"
				headings={["Site", "Agent", "Follow up", "Location/Event", "Date from", "Group size", "Quoted", "Age"]}
				noResults={enquiries.length === 0}
				noResultsMessage="This client hasn't got any open enquiries">
				{/* Print out the enquiries for this user */}
				{enquiries.map((enquiry) => (
					<Enquiry
						key={enquiry.id}
						id={enquiry.id}
						details={enquiry}
						showEnquiryWindow={(enquiryID) => history.push(`/enquiry/${enquiryID}`)}
					/>
				))}
			</Table>

			{/* Deleted enquiries section */}
			{deletedEnquiries.length > 0 && (
				<>
					<h3 style={{ marginTop: "30px", marginBottom: "10px", fontSize: "16px", fontWeight: 500 }}>Deleted Enquiries</h3>
					<Table
						className="enquiries-table"
						headings={["Site", "Agent", "Follow up", "Location/Event", "Date from", "Group size", "Quoted", "Age", "Status"]}
						noResults={deletedEnquiries.length === 0}
						noResultsMessage="This client doesn't have any deleted enquiries">
						{/* Print out the deleted enquiries for this user */}
						{deletedEnquiries.map((enquiry) => (
							<Enquiry
								key={enquiry.id}
								id={enquiry.id}
								details={enquiry}
								isDeleted={true}
								showEnquiryWindow={(enquiryID) => history.push(`/enquiry/${enquiryID}`)}
							/>
						))}
					</Table>
				</>
			)}

			{/* Are we adding a new enquiry? */}
			{addingEnquiry && (
				<Add
					clientID={clientID}
					close={() => setAddingEnquiry(false)}
				/>
			)}
		</>
	)
}
